// import moment from "moment";
import { combineEpics } from "redux-observable";
// import { from, of, timer } from "rxjs";
import { mergeMap } from "rxjs/operators";

// import { actionCreators, isOfAction } from "../actions";
// import { getFlag } from "../reducers/persist";
// import {
//     getMuteFor1Hour,
//     getMuteFor1Minute,
//     getMuteForever,
//     getMuteUntil8InMorning,
// } from "../utils/moment";
import { Epic } from "../utils/types";

// TODO use new mute API

// const on???: Epic = (action$, state$, { App }) =>
//     action$.pipe(
//         filter(isOfAction(actionCreators.on???)),
//         switchMap(({ payload: { data } }) => {
//             const {
//                 all_notifications_disabled_until_ts,
//                 follow_notifications_disabled_until_ts,
//             } = data;

//             // Collect all "muted until" timesstamps, global ones and for each room
//             const untilTss = [
//                 all_notifications_disabled_until_ts,
//                 follow_notifications_disabled_until_ts,
//             ];
//             Object.entries(data).forEach(([key, value]) => {
//                 const matchAll = key.match(/^all_notifications_disabled_until_ts\/(\S+)$/);
//                 const matchFollow = key.match(/^follow_notifications_disabled_until_ts\/(\S+)$/);
//                 if (typeof value === "number" && (matchAll || matchFollow)) {
//                     untilTss.push(value);
//                 }
//             });

//             const now = moment().unix();
//             const closest = untilTss
//                 .filter((x): x is number => x !== undefined && x > 0)
//                 // select only future tss
//                 .map(x => x - now)
//                 .filter(x => x > 0)
//                 // get earliest
//                 .sort((x, y) => x - y)[0];

//             // if (closest !== undefined && closest > 0) {
//             //     return timer(closest * 1000).pipe(
//             //         mergeMap(() => {
//             //             return [];
//             //         })
//             //     );
//             // }

//             return of<never>();
//         })
//     );

// const onMuteRoom: Epic = (action$, state$, { App }) =>
//     action$.pipe(
//         filter(isOfAction(actionCreators.muteRoom)),
//         mergeMap(({ payload: { roomId, type, period } }) => {
//             // const roomKey = `${
//             //     type === "everything"
//             //         ? "all_notifications_disabled_until_ts"
//             //         : "follow_notifications_disabled_until_ts"
//             // }/${roomId}`;

//             let until: number | undefined;
//             if (period === "forever") {
//                 until = getMuteForever();
//             } else if (period === "for_1_hour") {
//                 until = getFlag(state$.value, "short_mute")
//                     ? getMuteFor1Minute()
//                     : getMuteFor1Hour();
//             } else if (period === "until_8_am") {
//                 until = getMuteUntil8InMorning();
//             }

//             return [];
//         })
//     );

// const onUnmuteRoom: Epic = (action$, state$, { App }) =>
//     action$.pipe(
//         filter(isOfAction(actionCreators.unmuteRoom)),
//         mergeMap(({ payload: roomId }) => {
//             return [];
//         })
//     );

const onMuteRoom: Epic = action$ => action$.pipe(mergeMap(() => []));
const onUnmuteRoom: Epic = action$ => action$.pipe(mergeMap(() => []));

export const profileEpic = combineEpics(onMuteRoom, onUnmuteRoom);
